import { render, staticRenderFns } from "./AcclaimBadge.vue?vue&type=template&id=7061a056&scoped=true&"
import script from "./AcclaimBadge.vue?vue&type=script&lang=js&"
export * from "./AcclaimBadge.vue?vue&type=script&lang=js&"
import style0 from "./AcclaimBadge.vue?vue&type=style&index=0&id=7061a056&lang=scss&scoped=true&v-if=false&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061a056",
  null
  
)

component.options.__file = "AcclaimBadge.vue"
export default component.exports